import Sketch from '@qcolor/components/sketch';
import ColorPicker from '@qcolor/components/color-picker';
import ColorSketch from '@qcolor/components/color-sketch';

const components = [
  Sketch,
  ColorPicker,
  ColorSketch
];
export {
  components,
  Sketch,
  ColorPicker,
  ColorSketch
};